export default function UserIcon({
  size = 'w-[16px] h-[16px]',
  color = '#414651',
}) {
  return (
    <svg
      className={size}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10C10.2091 10 12 8.20914 12 6C12 3.79086 10.2091 2 8 2C5.79086 2 4 3.79086 4 6C4 8.20914 5.79086 10 8 10Z"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M1.9375 13.5006C2.55184 12.4363 3.43552 11.5525 4.49972 10.938C5.56392 10.3235 6.77113 10 8 10C9.22887 10 10.4361 10.3235 11.5003 10.938C12.5645 11.5525 13.4482 12.4363 14.0625 13.5006"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
